export const ORDER_ITEM_VOID_STATE = 'VOID';
export const ORDER_ITEM_IN_PROGRESS = 'IN_PROGRESS';
